import { render } from "./RealtyTable.vue?vue&type=template&id=70b7387d&scoped=true"
import script from "./RealtyTable.vue?vue&type=script&lang=js"
export * from "./RealtyTable.vue?vue&type=script&lang=js"

import "./RealtyTable.vue?vue&type=style&index=0&id=70b7387d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70b7387d"

export default script